import { Link } from "gatsby"
import React, { Component } from "react"

import logoDark from "../images/logo-dark.svg"

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="wrap">
          <img src={logoDark} width="128" />
          <div className="footer-info">
            <p>
              401 Bay Street Suite 2702
              <br />
              Toronto, Ontario
              <br />
              M5H 2Y4
            </p>
            <p>
              Toronto +1 647 930 9075
              <br />
              Toll Free +1 877 276 4822
              <br />
              Email info@thesfactor.co
              <br />
            </p>
            <p className="copyright">
              Copyright © The S Factor Co., a McCormick Inc.
              <br />
              company. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
